export default {
  Revenue_Org_ManuallyCopied_InviteLink: 'Revenue_Org_ManuallyCopied_InviteLink',
  Revenue_Org_Clicked_CopyInviteLinkButton: 'Revenue_Org_Clicked_CopyInviteLinkButton',
  Revenue_Org_Clicked_AcceptInvite: 'Revenue_Org_Clicked_AcceptInvite'
}
